export const WORKSPACE_ACCESS_REQUIREMENTS = {
    fullLogin: 'fullLogin',
    sso: 'sso',
    mfa: 'mfa',
};
